export default Object.freeze({
    transitionSpeed: 1000, // ms
})
